// extracted by mini-css-extract-plugin
module.exports = {"parentLink":"xr_xs","arrow":"xr_qk"};